import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const RemoveIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 10 10"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M5.73 5L9.84 0.89C10.05 0.68 10.05 0.36 9.84 0.16C9.64 -0.05 9.32 -0.05 9.11 0.16L5 4.27L0.89 0.16C0.68 -0.05 0.36 -0.05 0.16 0.16C-0.05 0.36 -0.05 0.68 0.16 0.89L4.27 5L0.16 9.11C-0.05 9.32 -0.05 9.64 0.16 9.84C0.26 9.95 0.42 10 0.52 10C0.62 10 0.78 9.95 0.89 9.84L5 5.73L9.11 9.84C9.22 9.95 9.38 10 9.48 10C9.58 10 9.74 9.95 9.84 9.84C10.05 9.64 10.05 9.32 9.84 9.11L5.73 5Z" />
		</svg>
	)
}

export default RemoveIcon
